import {API} from 'common/api';
import type {
  CheckTextSubmissionRequest,
  CodeRunRequest,
  CodeRunResponse,
  TextSubmission,
} from 'iq-questions/types';

export async function runCode(request: CodeRunRequest): Promise<CodeRunResponse> {
  const response = await API.post(`/v1/questions/submit/${request.question_uuid}`, request);
  if (response?.error) {
    return {success: false, message: response.error, test_cases: []};
  }
  return response as CodeRunResponse;
}

export async function checkTextSubmission(
  request: CheckTextSubmissionRequest,
): Promise<TextSubmission> {
  const response = await API.post('/v1/text-submissions/check', request);
  if (response?.error) {
    throw new Error(response.error);
  }
  return (response as {submission: TextSubmission}).submission;
}
